<template lang="">
  <div>
    <div id="header_top">
      <div id="header_top_langue" :class="{ 'header_top_langue2': $route.path === '/en' }">
        <a href="/home" class="cn">中文</a> | <a href="/en/home">ENGLISH</a>
      </div>
      <div id="header_logo">
        <a href="http://www.shzljt.com/"><img src="@/assets/images/logo.png"></a>
      </div>
      <div id="header_title" :class="{ 'header_title2': $route.path === '/en' }">
        <span>
          <p>
            <router-link to="/en/home" active-class="current">HOME</router-link>
          </p>
        </span>

        <!--走进中磊-->
        <span @mouseover="showAbout = true" @mouseleave="showAbout = false">
          <p>
            <router-link v-if="aboutList.length" active-class="current"
              :to="{path:'/en/about',query:{category_id:aboutList[0].id}}">ABOUT</router-link>
          </p>
          <ul v-if="aboutList.length" :class="{ hidden: !showAbout }">
            <li v-for="(item,index) in aboutList" :key="index">
              <router-link v-if="item.id!==5&&item.id!==7&&item.id!==8"
                :to="{path:'/en/about',query:{category_id:item.id}}">{{item.en_title}}</router-link>
              <router-link v-else-if="item.id==5"
                :to="{path:'/en/honor',query:{category_id:item.id}}">{{item.en_title}}</router-link>
              <router-link v-else-if="item.id==7"
                :to="{path:'/en/partner',query:{category_id:item.id}}">{{item.en_title}}</router-link>
              <router-link v-else-if="item.id==8"
                :to="{path:'/en/video',query:{category_id:item.id}}">{{item.en_title}}</router-link>
            </li>
          </ul>
        </span>

        <!--产品中心-->
        <span @mouseover="showProduct = true" @mouseleave="showProduct = false">
          <p><router-link v-if="productList.length" active-class="current"
              :to="{path:'/en/product',query:{category_id:productList[0].id}}">PRODUCT</router-link></p>
          <ul v-if="productList.length" :class="{ hidden: !showProduct }">
            <li v-for="(item,index) in productList" :key="index">
              <router-link :to="{path:'/en/product',query:{category_id:item.id}}">{{item.en_title}}</router-link>
            </li>
          </ul>
        </span>

        <!--案例中心-->
        <span @mouseover="showCase = true" @mouseleave="showCase = false">
          <p><router-link v-if="caseList.length" active-class="current"
              :to="{path:'/en/case',query:{category_id:caseList[0].id}}">CASE</router-link></p>
          <ul :class="{ hidden: !showCase }">
            <li v-for="(item,index) in caseList" :key="index">
              <router-link :to="{path:'/en/case',query:{category_id:item.id}}">{{item.en_title}}</router-link>
            </li>
          </ul>
        </span>

        <!--新闻动态?->
          <span>
            <p><a href="/news/index.html">新闻动�?/a></p>
            <ul>
                                    <li><a href="/news/category_1.html">公司新闻</a></li>
                                    <li><a href="/news/category_2.html">中磊公告</a></li>
                                    <li><a href="/news/category_4.html">海峡文化艺术中心</a></li>
                                    <li><a href="/news/category_3.html">项目动态</a></li>
                              </ul>
          </span>

             <!--新闻中心-->
        <span @mouseover="showNews = true" @mouseleave="showNews = false">
          <p><router-link v-if="newsList.length" active-class="current"
              :to="{path:'/en/news',query:{category_id:newsList[0].id}}">NEWS</router-link></p>
          <ul :class="{ hidden: !showNews }">
            <li v-for="(item,index) in newsList" :key="index">
              <router-link :to="{path:'/en/news',query:{category_id:item.id}}">{{item.en_title}}</router-link>
            </li>
          </ul>
        </span>

          <!--配套基地-->
        <span @mouseover="showCrafts = true" @mouseleave="showCrafts = false">
          <p><router-link v-if="craftsList.length" active-class="current"
              :to="{path:'/en/crafts',query:{category_id:craftsList[0].id}}">CRAFTS</router-link></p>
          <ul :class="{ hidden: !showCrafts }">
            <li v-for="(item,index) in craftsList" :key="index">
              <router-link :to="{path:'/en/crafts',query:{category_id:item.id}}">{{item.en_title}}</router-link>
            </li>
          </ul>
        </span>

        <!--联系我们-->
        <span @mouseover="showContact = true" @mouseleave="showContact = false">
          <p><router-link v-if="contactList.length" active-class="current"
              :to="{path:'/en/contact',query:{category_id:contactList[0].id}}">CONTACT</router-link></p>
          <ul :class="{ hidden: !showContact }">
            <li v-for="(item,index) in contactList" :key="index">
              <router-link v-if="item.id!==3" :to="{path:'/en/contact',query:{category_id:item.id}}">{{item.en_title}}</router-link>
              <router-link v-else :to="{path:'/en/message',query:{category_id:item.id}}">{{item.en_title}}</router-link>
            </li>
            <!-- <li><router-link :to="{path:'/en/message'}">在线留言</router-link></li> -->
          </ul>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        showAbout: false,
        showProduct: false,
        showCase: false,
        showCrafts: false,
        showContact: false,
        showNews: false,
        aboutList: [],
        newsList: [],
        productList: [],
        caseList: [],
        craftsList: [],
        contactList: [],
        messageList:[]
      }
    },
    mounted() {
      this.getAboutList();
      this.getProductList();
      this.getCases();
      this.getCrafts();
      this.getContact();
      this.getNews();
    },
    methods: {
      async getAboutList() {
        const res = await this.$request.post('aboutcategory/getAll')
        if (res.data.code === 0) {
          this.aboutList = res.data.data
        }
      },
      async getProductList() {
        const res = await this.$request.post('productcategory/getAll')
        if (res.data.code === 0) {
          this.productList = res.data.data
        }
      },
      async getCases() {
        const res = await this.$request.post('casescategory/getAll')
        if (res.data.code === 0) {
          this.caseList = res.data.data
        }
      },
      async getNews() {
        const res = await this.$request.post('newscategory/getAll')
        if (res.data.code === 0) {
          this.newsList = res.data.data
        }
      },
      async getCrafts() {
        const res = await this.$request.post('crafts/getAll')
        if (res.data.code === 0) {
          this.craftsList = res.data.data
        }
      },
      async getContact() {
        const res = await this.$request.post('contact/getAll')
        if (res.data.code === 0) {
          this.contactList = res.data.data
        }
      },
    
    },
  }
</script>
<style lang="css">
  .hidden {
    display: none;
  }
</style>